import { type FC } from 'react';

import { Button } from '@vakantiesnl/components/src/atoms/Button';
import { useMicroCopyContext } from '@vakantiesnl/services/src/context/microCopyContext';

import { useStyles } from './FilterAndSortBar.style';

type Props = {
	toggleFilter: () => void;
	toggleSort: () => void;
	filterCount: number;
};

export const FilterAndSortBar: FC<Props> = ({ toggleFilter, toggleSort, filterCount }) => {
	const { classes } = useStyles();
	const microCopy = useMicroCopyContext();

	return (
		<div className={classes.controlsPane}>
			<Button variant="tertiary" leadingIcon="filter" onClick={toggleFilter} size="small">
				{microCopy['search.controlsPane.filter']} <span className={classes.filterCount}>({filterCount})</span>
			</Button>
			<Button variant="tertiary" leadingIcon="sort" size="small" onClick={toggleSort}>
				{microCopy['search.controlsPane.sort']}
			</Button>
		</div>
	);
};
